<template>
  <el-container>
    <el-main style="padding: 0; margin-top: 5px;">
      <el-container direction="vertical" style="overflow-x: hidden">
        <el-row>
          <el-col :span="24">
            <div class="detail">
              <HeaderBar title="协会架构"></HeaderBar>
              <div class="detail__card">
                <img style="margin: 0 auto" src="../assets/img/jiagou.png"/>

              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>

import HeaderBar from '@/components/HeaderBar.vue';


// eslint-disable-next-line no-unused-vars
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name: 'JiaGouDetail',
  data() {
    return {
      content: '',
      createDate: '',
      files: [],
      title: ''
    };
  },
  components: { HeaderBar },

};
</script>

<style-scope lang="scss">
.detail {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: white;
  padding: 10px 10px 0px 10px;
  margin-bottom: 20px;
  &__card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 10px 10px 10px 10px;
    width: 100%;
    background-color: white;
    border-left: 1px solid #dcdcdc;
    border-right: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    box-sizing: border-box;
    border-radius: 0 0 15px 15px;
    &__title {
      background-color: white;
      width: 100%;
      line-height: 100px;
      color: black;
      font-size: 25px;
      font-weight: bold;
      align-self: center;
      text-align: center;
    }
  }
}

</style-scope>
